import type { Cents } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface DepositoryTransferResult {
    id: string;
    status: string;
}

export class DepositAccountRequestDetails {
    id!: string;
    isExternal!: boolean;
    isChargeSecuredAccount?: boolean;
}

export class DepositoryTransferRequest {
    amount!: Cents;
    fromDepositAccount!: DepositAccountRequestDetails;
    toDepositAccount!: DepositAccountRequestDetails;
    syncteraPersonId!: string;
    applyIncomeSplit?: boolean;
}

const useDepositoryTransfer = requestBuilder.mutation<
    DepositoryTransferResult,
    DepositoryTransferRequest
>({
    endpoint: '/api/depository-transfer',
    method: 'POST',
});

export default useDepositoryTransfer;
